import { createSelector } from 'reselect'
import { URL_TYPE } from 'pagesConfig/utils'

export const allSeoUrls = state => state.seoUrls.allUrls.urls

export const footerUrls = createSelector(
  allSeoUrls,
  urls => urls.filter(url => url.urlType === URL_TYPE.FOOTER)
)
